import { useEffect, useRef, useState } from "react";
import { Calendar, TrendingUp, Award, Shield } from "lucide-react";
import Reveal from "@/components/Reveal";

const stats = [
  { value: 18, suffix: "+", label: "anos transformando negócios", Icon: Calendar },
  { value: "1 → 17", label: "franquias em 36 meses", Icon: TrendingUp, isText: true },
  { value: "2025", label: "coautor Empretec SEBRAE/ONU", Icon: Award, isText: true },
  { value: "CRA/SC", label: "registro 26456", Icon: Shield, isText: true },
] as const;

const Counter = ({ to, suffix = "" }: { to: number; suffix?: string }) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [val, setVal] = useState(0);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      setVal(to);
      return;
    }

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        const start = performance.now();
        const dur = 1200;
        const tick = (now: number) => {
          const p = Math.min(1, (now - start) / dur);
          const eased = 1 - Math.pow(1 - p, 3);
          setVal(Math.round(eased * to));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        obs.disconnect();
      },
      { threshold: 0.4 }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, [to]);

  return (
    <span ref={ref}>
      {val}
      {suffix}
    </span>
  );
};

const StatsBar = () => {
  return (
    <section
      aria-label="Indicadores de trajetória"
      className="border-y border-border/60 bg-background-warm"
    >
      <div className="mx-auto grid max-w-6xl grid-cols-2 divide-border/60 md:grid-cols-4 md:divide-x">
        {stats.map((s, i) => {
          const Icon = s.Icon;
          return (
            <Reveal key={s.label} delay={i * 80}>
              <div className="px-6 py-10 md:px-8 md:py-14">
                <Icon
                  className="mb-4 h-5 w-5 text-accent/80 transition-transform duration-500 group-hover:scale-110"
                  aria-hidden="true"
                />
                <div className="font-serif text-3xl font-light text-accent md:text-4xl">
                  {"isText" in s && s.isText ? (
                    s.value
                  ) : (
                    <Counter to={s.value as number} suffix={"suffix" in s ? s.suffix : ""} />
                  )}
                </div>
                <div className="mt-2 text-xs uppercase tracking-[0.18em] text-muted-foreground">
                  {s.label}
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};

export default StatsBar;
